module.exports = ".pre-json {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere; }\n\n.input-container {\n  width: 25%;\n  margin-left: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/campaign/campaign-transactions/campaign-transactions.component.scss
// module id = ./src/app/modules/campaign/campaign-transactions/campaign-transactions.component.scss
// module chunks = main